import React, { Component, ComponentType } from 'react';
import { connect } from 'react-redux';
import NoAccess from '../components/views/NoAccess';
import { getTabIndex } from '../redux/dynamicTabs/selectors';
import { closeTab } from '../redux/dynamicTabs/actions';
import { RootState } from '../redux/reducers';

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

type ComponentProps = DynamicTabComponent & { state: DynamicTabWithTable<unknown> | DynamicTabWithForm<unknown>; history: any };
export type NoAccessToResource = ComponentProps & MapStateToProps & MapDispatchToProps;

/**
 * HOC zwracający widok w momencie braku dostępu do podanej zakładki.
 *
 * @param Cmp
 */
const withNoAccessToResource = <P extends ComponentProps>(Cmp: ComponentType<P>) => {
  class Controller extends Component<NoAccessToResource> {
    render(): React.ReactElement {
      const { closeTab, tabIndex, ...rest } = this.props;
      return this.props.state.noAccess ? <NoAccess closeTab={closeTab.bind(null, tabIndex)} /> : <Cmp {...(rest as P)} />;
    }
  }
  return connect(mapStateToProps, mapDispatchToProps)(Controller);
};
const mapStateToProps = (state: RootState, { id }: ComponentProps) => ({
  tabIndex: getTabIndex(state, id),
});
const mapDispatchToProps = (dispatch: any, props: ComponentProps) => ({
  closeTab: (tabIndex: number) => dispatch(closeTab(tabIndex, props.history)),
});

export default withNoAccessToResource;
